import defaultAvatar from '../assets/img/default-avatar.png'
import defaultBoyAvatar from '../assets/img/defaultBoyAvatar.svg'
import defaultGirlAvatar from '../assets/img/defaultGirlAvatar.svg'

export const getDefaultAvatar = (gender: string) => {
  switch (gender) {
    case 'male':
      return defaultBoyAvatar
    case 'female':
      return defaultGirlAvatar
    default:
      return defaultAvatar
  }
}

export default {
  getDefaultAvatar
}



// WEBPACK FOOTER //
// ./src/services/avatar.ts